import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { isAdminRole } from 'src/app/core/model/tenants/user-profile.model';
import { TenantClientService } from 'src/app/core/services/tenant-client.service';

/** Blocks non-admin tenant roles from the system/* routes. Fetches the profile
 *  fresh (rather than reading AppService's cached one) since that cache is
 *  refreshed on NavigationStart and may not have settled for the tenant being
 *  navigated to yet. */
export const adminGuard: CanActivateFn = (route) => {
  const tenantClient = inject(TenantClientService);
  const router = inject(Router);
  const tenantCode = route.paramMap.get('tenantCode');

  if (!tenantCode) {
    return true;
  }

  return tenantClient.getUserProfile(tenantCode).pipe(
    map((profile) => isAdminRole(profile.role) || router.createUrlTree(['/', tenantCode])),
    catchError(() => of(router.createUrlTree(['/', tenantCode]))),
  );
};
